import { useEffect, useState } from 'react'

import { useServerTimeOffsetMs } from '~/hooks/useServerTimeOffsetMs'
import { now as serverNow } from '~/models/clock'
import {
  isMarketClosed,
  marketOpenAt,
} from '~/pages/IntradayBidding/models/marketOpen'

/** setTimeout が受け付ける遅延の上限 (約 24.8 日)。 超えると即時に発火する。 */
const MAX_TIMEOUT_MS = 2 ** 31 - 1

/** 受渡日が未開場か。 `active` の間は開場時刻に再描画し、 開いたまま開場をまたぐと false になる (AC-BIN-005a)。 */
export function useIntradayMarketClosed(
  deliveryDate: Date,
  active: boolean,
): boolean {
  const offsetMs = useServerTimeOffsetMs()
  const [tick, setTick] = useState(0)
  const openAtMs = marketOpenAt(deliveryDate).getTime()
  const closed = isMarketClosed(serverNow(), deliveryDate)
  useEffect(() => {
    if (!active || !closed) return
    const remainingMs = openAtMs - serverNow().getTime()
    const id = setTimeout(
      () => setTick((n) => n + 1),
      Math.min(Math.max(remainingMs, 0), MAX_TIMEOUT_MS),
    )
    return () => clearTimeout(id)
  }, [active, closed, openAtMs, offsetMs, tick])
  return closed
}
